module.exports = __webpack_public_path__ + "images/d68a20eb.png";